export enum UriSchemaType {
    MailTo = 'mailto',
    Tel = 'tel',
    Website = 'website',
}
